import type { ReactNode } from 'react';

import styles from '@/admin/components/AdminSelect.module.scss';

type AdminSelectProps = {
  value: string;
  onChange: (value: string) => void;
  children: ReactNode;
  label?: string;
};

export const AdminSelect = ({ value, onChange, children, label }: AdminSelectProps) => (
  <select
    className={styles.select}
    value={value}
    aria-label={label}
    onChange={(e) => onChange(e.target.value)}
  >
    {children}
  </select>
);
